import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy
} from '@angular/core';

@Component({
    selector: 'app-arrow',
    templateUrl: './arrow.component.html',
    styleUrls: ['./arrow.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ArrowComponent implements OnInit {
  @Input() direction: 'up' | 'down';
  @Input() color: string;

  constructor() {}

  ngOnInit() {}
}
